<mat-form-field [ngClass]="cssClass">
  <input matInput [placeholder]="placeholderText" [matAutocomplete]="auto" [ngModelOptions]="{standalone: true}" (ngModelChange)="onLocationSearchChanged($event)" [(ngModel)]="selectedLocation">
  <mat-autocomplete (optionSelected)="onOptionSelected()" #auto="matAutocomplete" [displayWith]="displayFnc">
    <mat-option *ngIf="isLoadingLocations" class="is-loading">Loading...</mat-option>
    <mat-option *ngFor="let locationSearchResult of locationSearchResults" [value]="locationSearchResult">
      {{locationSearchResult.address}}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
